import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { RecentsModule } from 'apps/idl/src/modules/preferences/recents/recents.module';
import { SceService } from './services/sce.service';

@NgModule({
	declarations: [],
	exports: [],
	imports: [
		CommonModule,
		IonicModule,
		RecentsModule.forRoot({ limit: 1 }),
	],
	providers: [SceService]
})
export class SceModule { }
